import { Message } from '@arco-design/web-react'
import { getSystemStatusApi } from '@/api/status'
import { useStatusStore } from '@/stores/statusStore'
import { keysNeedStatusRefresh, keysNeedTopupRefresh } from './optionMeta'

/** 按已保存 key 刷新全局 status 等副作用 */
export async function runOptionAfterSave(savedKeys: string[], skippedSensitive: string[]): Promise<void> {
  const hints: string[] = []

  if (skippedSensitive.length > 0) {
    hints.push(`已跳过 ${skippedSensitive.length} 个敏感字段（留空不覆盖）`)
  }

  if (keysNeedStatusRefresh(savedKeys)) {
    try {
      const status = await getSystemStatusApi()
      useStatusStore.getState().setStatus(status || {})
      hints.push('已刷新系统状态')
    } catch {
      hints.push('系统状态刷新失败，建议刷新页面')
    }
  }

  if (keysNeedTopupRefresh(savedKeys)) {
    hints.push('充值相关配置已更新；用户侧充值页需重新打开以获取最新金额选项')
  }

  if (hints.length > 0) {
    Message.info(hints.join('；'))
  }
}
